/**
 * Environment Configuration Module
 *
 * Purpose: Centralized environment variable access for Vite applications
 * Note: This file is mocked in Jest tests to avoid import.meta syntax errors
 */

/**
 * Application environment configuration
 * Exports environment variables from Vite's import.meta.env
 */
export const env = {
  /** API base URL for core-api service */
  apiUrl: import.meta.env.VITE_API_URL || '/core-api',

  /** Development mode flag */
  isDev: import.meta.env.DEV || false,

  /** Production mode flag */
  isProd: import.meta.env.PROD || true,

  /** Build mode (development, production, test) */
  mode: import.meta.env.MODE || 'production',

  /** Base URL for the application */
  baseUrl: import.meta.env.BASE_URL || '/',
};
